import type { PlatformBadge as PlatformBadgeData } from "data/platforms"

interface Props {
  badge: PlatformBadgeData
  className?: string
  /** Render as a link when the badge has an href. Set false inside cards
   *  (which are already anchors) to avoid nested <a>. */
  interactive?: boolean
}

/**
 * Small museum-wall-label style badge marking the gallery/platform a piece was
 * released through. Theme-aware text wordmark; if an official monochrome logo
 * is later dropped at /logos/platforms/<id>.svg it can be layered in via the
 * `gallery-platform-badge--<id>` hook without touching call sites.
 */
const PlatformBadge = ({ badge, className = "", interactive = true }: Props) => {
  const classes = `gallery-platform-badge gallery-platform-badge--${badge.id} ${className}`.trim()

  if (badge.href && interactive) {
    return (
      <a
        href={badge.href}
        target="_blank"
        rel="noopener noreferrer"
        className={classes}
        title={badge.tooltip}
        aria-label={badge.tooltip}
      >
        {badge.label}
      </a>
    )
  }

  return (
    <span className={classes} title={badge.tooltip} aria-label={badge.tooltip}>
      {badge.label}
    </span>
  )
}

export default PlatformBadge
